export default __webpack_public_path__ + "static/media/0.f9265304.png";